
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import MainButton from "../../../common/MainButton";
import Link from "next/link";
const PreorderItem = ({ item, values }) => {
    return <li className={'preorder_list_item'}>
        <div className="item_wrapper">
            <h3>{item.title}</h3>
            <p className={'item_price'}>{values[item.key].price}
                {/*.<span className={'item_price_small'}>00</span>*/}
            </p>
            <div className={'item_status'}>
                {values[item.key].sold_out ? <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M29 57C44.464 57 57 44.464 57 29C57 13.536 44.464 1 29 1C13.536 1 1 13.536 1 29C1 44.464 13.536 57 29 57Z" stroke="#3366FF"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M29 57C44.464 57 57 44.464 57 29C57 13.536 44.464 1 29 1C13.536 1 1 13.536 1 29C1 44.464 13.536 57 29 57Z" fill="#3366FF"/>
                    <path d="M18.0015 29.4L25.5755 35L38.0015 21" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                </svg> : <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M29 57C44.464 57 57 44.464 57 29C57 13.536 44.464 1 29 1C13.536 1 1 13.536 1 29C1 44.464 13.536 57 29 57Z" stroke="#979797"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M29 57C44.464 57 57 44.464 57 29C57 13.536 44.464 1 29 1C13.536 1 1 13.536 1 29C1 44.464 13.536 57 29 57Z" fill="black"/>
                    <g clipPath="url(#clip0_1060_1762)">
                    <path d="M34.5015 40C33.6732 40 33.0015 39.3283 33.0015 38.5C33.0015 37.6717 33.6732 37 34.5015 37C35.3301 37 36.0015 37.6717 36.0015 38.5C36.0015 39.3283 35.3301 40 34.5015 40Z" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                    <path d="M23.5015 40C22.673 40 22.0015 39.3283 22.0015 38.5C22.0015 37.6717 22.673 37 23.5015 37C24.3299 37 25.0015 37.6717 25.0015 38.5C25.0015 39.3283 24.3299 40 23.5015 40Z" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                    <path d="M17.0015 18H21.1596L21.5973 22.2105M21.5973 22.2105L22.963 34H34.83L38.0015 22.2105H21.5973Z" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                    <path d="M27.0015 28.4L28.895 30L32.0015 26" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_1060_1762">
                    <rect width="24" height="24" fill="white" transform="translate(16 17)"/>
                    </clipPath>
                    </defs>
                    </svg>}
            </div>
            <p className={'item_purchases'}>{values[item.key].range} {item.purchases}</p>
            {values[item.key].sold_out ? <button className={'main_button soldout_cta'}>{item.sold_out}</button> :
            values[item.key].price === '$349' ?
                <Link className={'item_cta'} href={process.env.NEXT_PUBLIC_APP_URL + '/'}>
                    <MainButton nw={true} title={'Pre-Order Now'}/>
                </Link> : <Link className={'item_cta'} href={process.env.NEXT_PUBLIC_APP_URL + '/'}>
                        <MainButton title={item.preorder}/>
                    </Link>}
        </div>
    </li>;
};
const Preorder = ({ content, values, sold_amount }) => {
    return (<section className={'preorder'}>
            <div className="container">
                <section className={'preorder_wrapper'}>
                    <div className={'preorder_title'}>
                        <span className={'preorder_title_label'}>{content.label}</span>
                        <h2 className={'preorder_title_title'}>{content.title}</h2>
                        {/*<div className={'preorder_title_sold'}>*/}
                        {/*    <span className={'sold_title'}>{content.sold_amount}</span>*/}
                        {/*    <span className={'sold_amount'}>{sold_amount}</span>*/}
                        {/*</div>*/}
                    </div>
                    <ul className="preorder_list">
                        {content.items.map(item => {
            return <PreorderItem key={item.key} item={item} values={values}/>;
        })}
                    </ul>
                </section>
            </div>
        </section>);
};
export default Preorder;

    async function __Next_Translate__getStaticProps__1973b766b4f__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//hardware/Preorder/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1973b766b4f__ as getStaticProps }
  